import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import { FormItemCommonProps, FormItemContent } from "./common";
import { TzPicker, TzPickerProps } from "@/routes/dashboard/-tz-picker";
import { FormField } from "@/components/ui/form";
import { callAll } from "@/lib/utils";

export type FormTzPickerItemProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TContext,
  TTransformedValues extends FieldValues | undefined,
> = {
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>;
  name: TName;
} & FormItemCommonProps &
  Omit<TzPickerProps, "form">;

export type FormTzPickerItemCommonProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
> = Omit<
  FormTzPickerItemProps<TFieldValues, TName, TContext, TTransformedValues>,
  "form" | "name" | "label" | "required" | "form"
> &
  Partial<Pick<FormItemCommonProps, "label">>;

export function FormTzPickerItem<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  form,
  name,
  label,
  container,
  onChange,
  onBlur,
  ...props
}: FormTzPickerItemProps<TFieldValues, TName, TContext, TTransformedValues>) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItemContent
          {...container}
          label={label}
          //   inline={container?.inline ?? props?.inline}
        >
          <TzPicker
            {...(field as any)}
            {...props}
            onChange={callAll(field.onChange, onChange)}
            onBlur={callAll(field.onBlur, onBlur)}
          />
        </FormItemContent>
      )}
    />
  );
}
